module.exports = __webpack_public_path__ + "media/images/admin/icons/mail-eee1baa73917a6ad8cc5ab655510875a.svg";